export default [
  {
    title: 'OOTD',
    description: 'OOTD is an instagram like project. Users can upload one outfit daily and tag brands of what they are wearing.',
    no_preview: true,
    progress: 10,
    techs: [
      {name: 'Django', icon: 'mdi-language-python', color: 'teal darken-2'},
      {name: 'Flutter', icon: 'mdi-cellphone', color: 'light-blue darken-1'},
      {name: 'MySQL', icon: 'mdi-database'},
    ]
  },
  {
    title: 'Party',
    description: 'Making an app to help party organizers with their tasks. Creating an event, creating different packages if it is a paid event, keep track of guests who came or not.',
    no_preview: true,
    progress: 12,
    techs: [
      {name: 'Node/Express', icon: 'mdi-language-javascript', color: 'yellow darken-2'},
      {name: 'React', icon: 'mdi-react', color: 'light-blue darken-1'},
      {name: 'Tailwind', icon: 'mdi-language-css3', color: 'blue darken-1'},
      {name: 'Vite', icon: 'mdi-nut', color: 'deep-purple lighten-3'},
      {name: 'Maria', icon: 'mdi-database'},
    ]
  },
]